export const dateToday = "May 20, 2026 08:45 A.M";
